module.exports = __webpack_public_path__ + "img/paperclip.2bc47617.svg";